import { ReactElement, useState } from 'react';
import {
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import styles from './SingleTourChart.module.scss';

import CustomTooltip from '../../CustomTooltip/CustomTooltip';
import Options from '../../Options/Options';
interface ChartDataFormat {
  name: string;
  Views: number;
}

interface Props {
  lastWeekData: ChartDataFormat[];
  lastMonthData: ChartDataFormat[];
  lastYearData: ChartDataFormat[];
}

function SingleTourChart({
  lastWeekData,
  lastMonthData,
  lastYearData,
}: Props): ReactElement {
  const [activeTab, setActiveTab] = useState('year');
  const [focusBar, setFocusBar] = useState(null);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onMouseMove = (state: any) => {
    if (state.isTooltipActive) {
      setFocusBar(state.activeTooltipIndex);
    } else {
      setFocusBar(null);
    }
  };

  const getChartData = () => {
    if (activeTab === 'week') {
      return lastWeekData;
    }
    if (activeTab === 'month') {
      return lastMonthData;
    }
    return lastYearData;
  };

  const chartData = getChartData();

  return (
    <div className={styles.outer}>
      <Options
        isMain={false}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        options={['week', 'month', 'year']}
        data={getChartData()}
      />

      <div style={{ height: '300px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            width={500}
            height={300}
            data={chartData}
            margin={{
              top: 5,
              right: 0,
              left: 0,
              bottom: 5,
            }}
            onMouseMove={onMouseMove}
            barSize={25}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" axisLine={false} />
            <YAxis />
            <Tooltip
              content={<CustomTooltip />}
              cursor={{ fill: 'transparent' }}
            />
            <Bar dataKey="Views" fill="#DCDDE0" radius={[10, 10, 0, 0]}>
              {chartData.map((entry, index) => {
                return (
                  <Cell
                    key={entry.name + entry.Views}
                    fill={focusBar === index ? '#e544ff' : '#DCDDE0'}
                  />
                );
              })}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default SingleTourChart;
